// File: client_serena/src/App.js

import Signup from "./pages/Signup";
import { CartProvider } from "./context/CartContext";

import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

import ChakraTest from "./pages/ChakraTest";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import Footer from "./components/Footer";

import Login from "./pages/Login";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminKitchenDashboard from "./pages/AdminKitchenDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { AuthProvider } from "./context/AuthContext";
import FetchUserData from "./components/FetchUserData";
import TokenLogger from "./components/TokenLogger";
import AdminRejectedMeals from "./pages/AdminRejectedMeals";
import ToastTest from "./pages/ToastTest";

import PaymentHistoryPage from "./pages/PaymentHistoryPage";
import ConfirmationPage from "./pages/ConfirmationPage";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FloatingCartButton from "./components/FloatingCartButton";

import SiteHeader from "./institutional/SiteHeader";
import SiteFooter from "./institutional/SiteFooter";
import "./institutional/institutional.css";

import HomePage from "./pages/institutional/HomePage";
import WorkPage from "./pages/institutional/WorkPage";

import InstitutePage from "./pages/institutional/InstitutePage";
import SeminarDataToIntelligencePage from "./pages/institutional/seminarDataToIntelligencePage";
import ResourcesPage from "./pages/institutional/ResourcesPage";
import AboutPage from "./pages/institutional/AboutPage";
import CommunityPage from "./pages/institutional/CommunityPage";
import PartnerPage from "./pages/institutional/PartnerPage";

import PrivacyPage from "./pages/institutional/PrivacyPage";

const institutionalRoutes = [
  "/",
  "/work",
  "/institute",
  "/institute/seminars/from-african-health-data-to-actionable-intelligence",
  "/community",
  "/partner",
  "/about",
  "/resources",
  "/privacy",
];


function AppShell({ children }) {
  const location = useLocation();

  const normalizedPath =
    location.pathname === "/"
      ? "/"
      : location.pathname.replace(/\/$/, "");

  const isInstitutionalRoute =
    institutionalRoutes.includes(normalizedPath);

  return isInstitutionalRoute ? (
    <div className="serena-site">
      <SiteHeader />
      {children}
      <SiteFooter />
    </div>
  ) : (
    <>
      <Navbar />
      {children}
      <FloatingCartButton />
      <Footer />
    </>
  );
}


function App() {
  return (
    <ChakraProvider>
      <AuthProvider>
        <CartProvider>
          <Router>
            <FetchUserData />
            <TokenLogger />

            <ToastContainer
              position="top-right"
              autoClose={4000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              pauseOnHover
              draggable
              theme="light"
            />

            <AppShell>
              <Routes>

                {/* =========================
                    INSTITUTIONAL WEBSITE
                    ========================= */}

                <Route path="/" element={<HomePage />} />

                {/* Placeholder routes — pages will be built next */}
                <Route path="/work" element={<WorkPage />} />
                <Route path="/institute" element={<InstitutePage />} />
                <Route
                  path="/institute/seminars/from-african-health-data-to-actionable-intelligence"
                  element={<SeminarDataToIntelligencePage />}
                />
                <Route path="/community" element={<CommunityPage />} />
                <Route path="/partner" element={<PartnerPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />


                {/* =========================
                    EXISTING APPLICATION
                    ========================= */}

                <Route path="/register" element={<Signup />} />
                <Route path="/login" element={<Login />} />

                <Route
                  path="/admin/rejected-meals"
                  element={<AdminRejectedMeals />}
                />

                <Route path="/test-toast" element={<ToastTest />} />
                <Route path="/chakra-test" element={<ChakraTest />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/app/privacy" element={<PrivacyPolicy />} />
                <Route path="/signup" element={<Signup />} />
                <Route
                  path="/payment-history"
                  element={<PaymentHistoryPage />}
                />
                <Route
                  path="/confirmation"
                  element={<ConfirmationPage />}
                />

                <Route
                  path="/user/dashboard"
                  element={
                    <ProtectedRoute role="user">
                      <UserDashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/dashboard"
                  element={
                    <ProtectedRoute role="admin">
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/kitchen"
                  element={
                    <ProtectedRoute role="admin">
                      <AdminKitchenDashboard />
                    </ProtectedRoute>
                  }
                />

              </Routes>
            </AppShell>
          </Router>
        </CartProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App;


























